<mat-drawer-container autosize>
  <mat-drawer opened="true" mode="side">
    <div class="list-container">
      <sm-graph-settings-bar
        class="drawer-settings-bar"
        [verticalLayout]="true"
        [smoothWeight]="smoothWeight$ | async"
        [smoothType]="smoothType$ | async"
        [xAxisType]="xAxisType$ | async"
        [groupBy]="groupBy"
        [groupByOptions]="groupByOptions"
        (changeWeight)="changeSmoothness($event)"
        (toggleSettings)="toggleSettingsBar()"
        (changeXAxisType)="changeXAxisType($event)"
        (changeGroupBy)="changeGroupBy($event)"
        (changeSmoothType)="changeSmoothType($event)"
      ></sm-graph-settings-bar>
      <sm-selectable-grouped-filter-list
        [list]="graphList"
        [selected]="selectedGraph"
        [checkedList]="listOfHidden | async"
        [searchTerm]="searchTerm$ | async"
        (itemSelect)="metricSelected($event)"
        (hiddenChanged)="hiddenListChanged($event)"
        (searchTermChanged)="searchTermChanged($event)"
      >
      </sm-selectable-grouped-filter-list>
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <sm-experiment-graphs
      [metrics]="graphs"
      [hiddenList]="listOfHidden | async"
      [isGroupGraphs]="false"
      [isCompare]="true"
      [hoverMode]="hoverMode$ | async"
      [smoothWeight]="smoothWeightDelayed$ | async"
      [smoothType]="smoothType$ | async"
      [xAxisType]="xAxisType$ | async"
      [exportForReport]="!modelsFeature"
      (resetGraphs)="resetMetrics()"
      (hoverModeChanged)="hoverModeChanged($event)"
      (createEmbedCode)="createEmbedCode($event)"
    >
    </sm-experiment-graphs>
  </mat-drawer-content>
</mat-drawer-container>
